export default function navigateBack(state) {
	return {
		type: 'NAVIGATE_BACK',
	};
}


// WEBPACK FOOTER //
// ./src/actions/navigateBack.js